export default "__VITE_ASSET__BXF$0xZA__"